import { MenuItem, Select } from "@mui/material";
import { buildClass, checkClass } from "@utils/tag";
import useTranslation from "next-translate/useTranslation";
import { Icon } from "@utils/helper";

const LangTitle = ({ icon, title, lang, langNav }) => {
  return (
    <div className="flex items-center justify-between gap-2 text-[12px] mx-3 sm:text-base md:text-lg font-semibold">
      {icon && <img alt="icon" src={icon} className="w-[16px]" />}
      <span className={lang === "ar" && langNav && "absolute left-9 top-[6px]"}>
        {title}
      </span>
    </div>
  );
};
const SelectBase = ({
  selectWidth,
  listWidth,
  borderBottom,
  id,
  defaultValue,
  itemClass = "ps-5",
  handleChange,
  list,
  selected,
  selectBg = "#FFF",
  listBg = "#FFF",
  border,
  callback,
  selectColor = "#333333",
  selectLeft = "left-3",
  selectRadius = "42px",
  selectedBg = "transparent !important",
  selectedColor = "#333333",
  itemColor = "#8F8F8F",
  colorHover = "#F8FBFF",
  placeholder,
  langNav,
  options,
  top = 0,
  sx = {},
  paperSx = {},
}) => {
  const { lang } = useTranslation();
  return (
    <Select
      id={id}
      value={selected}
      defaultValue={defaultValue}
      onChange={handleChange}
      displayEmpty
      renderValue={(selected) => {
        const selectedItem = list?.find((item) => item.value === selected);
        return placeholder ? (
          selectedItem ? (
            <LangTitle
              lang={lang}
              icon={selectedItem.icon}
              title={selectedItem.title}
              langNav={langNav}
            />
          ) : (
            <LangTitle lang={lang} title={placeholder} langNav={langNav} />
          )
        ) : null;
      }}
      IconComponent={({ className }) => {
        const isOpen = className.split(" ").includes("MuiSelect-iconOpen");
        return (
          <div
            className={buildClass(
              "absolute cursor-pointer pointer-events-none",
              checkClass(lang === "en", ["right-3", selectLeft])
            )}
          >
            <Icon
              height={15}
              color={selectColor}
              className={`transition-transform duration-300 ${
                isOpen ? "rotate-90" : "-rotate-90"
              }`}
              id="Arrow"
              viewBox="0 0 6 11"
            />
          </div>
        );
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            mt: top,
            backgroundColor: listBg,
            borderRadius: "20px",
            color: itemColor,
            width: listWidth ?? selectWidth,
            "& li": {
              position: "relative",
              justifyContent: "space-between",
            },
            "& li:hover": {
              backgroundColor: colorHover,
            },
            "& li:not(:last-child):before": {
              content: "''",
              position: "absolute",
              bottom: "0",
              width: "calc(100% - 60px)",
              height: borderBottom ? "1px" : "0px",
              backgroundColor: "#8F8F8F29",
              left: "50%",
              transform: "translateX(-50%)",
            },
            "& li.Mui-selected ": {
              backgroundColor: selectedBg,
              color: selectedColor,
              fontWeight: "600",
              fontSize: "14px",
              lineHeight: "19px",
            },
            ...paperSx,
          },
        },
        ...options,
      }}
      sx={{
        boxShadow: "none",
        width: selectWidth,
        position: "relative",
        border: border ? "1px solid #E5E5E5" : "none",
        borderRadius: border ? "43px" : "0",
        ".MuiOutlinedInput-notchedOutline": { border: 0 },
        ".MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          gap: "1.25rem",
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "21px",
          borderRadius: selectRadius,
          paddingTop: "10px",
          paddingBottom: "10px",
          backgroundColor: selectBg,
          color: selectColor,
        },
        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          border: 0,
        },
        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            border: 0,
          },
        ".selected": {
          display: "none",
        },
        ...sx,
      }}
    >
      {list?.map(({ value, title, icon, ...rest }) => (
        <MenuItem
          key={value}
          value={value}
          onClick={() => callback && callback({ value, title, icon, ...rest })}
          className={buildClass(
            "flex justify-between items-center",
            "font-medium text-sm leading-[19px] !py-4"
          )}
        >
          <div className={buildClass("flex items-center gap-4", itemClass)}>
            {icon && (
              <img alt="icon" src={icon} className="w-[18px] h-[18px]" />
            )}
            <span
              className={buildClass(
                checkClass(lang === "ar", ["absolute right-12", ""]),
                { "top-[14px]": lang === "ar" && langNav }
              )}
            >
              {title}
            </span>
          </div>
          {value === selected && (
            <img
              alt="check icon"
              src="/images/global/check.png"
              className="w-[14px] selected"
            />
          )}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectBase;
